import { useState } from "react";
import { useAddCouponsMutation } from "../../Services/CouponsAPI";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

function AddCategory() {
    const navigate = useNavigate();
    const [code,setCode] = useState("")
    const [discount, setDiscount] = useState("");
    const [type, setType] = useState("percentage");
    const [validFrom, setValidFrom] = useState("");
    const [validUntil, setValidUntil] = useState("");
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);


    const [addCategory, { isLoading }] = useAddCouponsMutation();

    const validateForm = () => {
        let newErrors = {};
        if (!code) newErrors.code = "Coupon code is required";
        if (!discount.trim() || isNaN(discount)) {
            newErrors.discount = "Discount must be a number";
        }
        if (!validFrom) newErrors.validFrom = "Valid from date is required";
        if (!validUntil) newErrors.validUntil = "Valid until date is required";
        if (validFrom && validUntil && new Date(validFrom) >= new Date(validUntil)) {
            newErrors.validUntil = "Valid until date must be after valid from date";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("code", code);
        formData.append("discount", discount);
        formData.append("type", type);
        formData.append("valid_from", validFrom);
        formData.append("valid_until", validUntil);

        try {
            await addCategory(formData).unwrap();
            alert("Coupon added successfully!");
            setDiscount("");
            setDiscount("");
            setType("percentage");
            setValidFrom("");
            setValidUntil("");
            setErrors({});
            setApiError(null);
            navigate("/coupon-list");
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>Add Coupon</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/coupon-list"><span>Back</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Add</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                    <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Coupon Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Coupon Code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                {errors.code && <p className="text-danger">{errors.code}</p>}
                            </div>
                        </div>

                        {/* Discount */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Discount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Discount"
                                    value={discount}
                                    onChange={(e) => setDiscount(e.target.value)}
                                />
                                {errors.discount && <p className="text-danger">{errors.discount}</p>}
                            </div>
                        </div>

                        {/* Type */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Type</label>
                                <select
                                    className="form-control"
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <option value="percentage">Percentage</option>
                                    <option value="fixed">Fixed</option>
                                </select>
                            </div>
                        </div>

                        {/* Valid From */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Valid From</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={validFrom}
                                    onChange={(e) => setValidFrom(e.target.value)}
                                />
                                {errors.validFrom && <p className="text-danger">{errors.validFrom}</p>}
                            </div>
                        </div>

                        {/* Valid Until */}
                        <div className="col-md-6">
                            <div className="mb-4">
                                <label className="form-label">Valid Until</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={validUntil}
                                    onChange={(e) => setValidUntil(e.target.value)}
                                />
                                {errors.validUntil && <p className="text-danger">{errors.validUntil}</p>}
                            </div>
                        </div>
                    </div>

                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
